import _ from "lodash";

export function reBuildColumns(columns, typeShows) {
    return _.filter(columns, column => {
        return _.every(typeShows, typeShow => {
            if (typeShow.name === column.type || typeShow.name === column.title) {
                return !!typeShow.isShow;
            }
            return true;
        });
    });
}
